module.exports = __webpack_public_path__ + "img/1584645264207464214.ec7877b5.jpg";